// extracted by mini-css-extract-plugin
module.exports = {"container":"Sf","timeTop":"Tf","timeCountdown":"Uf","cta":"Vf","disabled":"Wf","product":"Xf"};